
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import ImageSelector from '@/components/ImageSelector.vue';

  @Component({
    components: {ImageSelector},
  })
  export default class DlgEventDelete extends Vue {
    @Prop({type: Object, default: null}) private event!: any;

    @Action('admin/events/remove') private deleteEvent!: any;
    @Action('admin/events/read') private readEvents!: any;
    @Getter('common/rules/all') private rules!: any;

    private dialog: boolean = false;
    private loading: boolean = false;

    private async del() {
      this.loading = true;
      await this.deleteEvent(this.event);
      await this.readEvents();
      this.dialog = false;
      this.loading = false;
    }
  }
